<script lang="ts">
  /**
   * Zetix Z-mark — monochrome geometric Z in 24×24 viewBox.
   *
   * Derived from the legacy 256×256 path (top bar → diagonal slash → bottom bar),
   * but simplified with sharper inner chamfer so the letter reads at 20px.
   */
  interface Props {
    size?: number;
    class?: string;
  }
  let { size = 20, class: cls = '' }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
  class={cls}
  aria-hidden="true"
>
  <!-- Geometric Z: top bar + diagonal spine + bottom bar in one path -->
  <path d="M2 2h20v6h-9.5L22 22H2v-6h9.5L2 2z" />
</svg>
